import i18next from "i18next";
import moment from "moment";

import { VALIDATION_MESSAGE } from "../../constants";
import { DATE_FORMAT, DATETIME_FORMAT } from "../../constants/dateFormats";

const Validation = {
  combine(required, validation) {
    return (value) => {
      let message = "";
      if (required) {
        message = this.required(value);
      }
      if (validation) {
        message = validation(value);
      }

      return message;
    };
  },
  noop() {
    return "";
  },
  required(value) {
    const missingValue = !value || value.length === 0;
    if (missingValue) {
      return VALIDATION_MESSAGE.REQUIRED;
    }
    return "";
  },
  requiredObjectAutocomplete(value) {
    const missingValue = !(value && typeof value === "object") || Array.isArray(value) ? !value?.length : false;
    if (missingValue) {
      return VALIDATION_MESSAGE.AUTOCOMPLETE_OBJECT;
    }
    return "";
  },
  email(value) {
    if (!/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)) {
      return VALIDATION_MESSAGE.EMAIL_FORMAT_WRONG;
    }
    return "";
  },
  verifyPassword(value) {
    const { password, passwordVerification } = value;
    if (!!password) {
      if (password !== passwordVerification) {
        return VALIDATION_MESSAGE.PASSWORDS_DO_NOT_MATCH;
      }
      if (!/[A-Z]+/.test(password) || !/[0-9]+/.test(password) || password?.length < 8) {
        return VALIDATION_MESSAGE.PASSWORD_CONSTRAINTS_ERROR;
      }
    }
    return "";
  },
  verifyDatetimeFormat(value) {
    if (value) {
      // Strict parse of the stored formats. The date-time picker stores "Invalid date" for an incomplete
      // date-time, and `new Date()` accepts impossible dates and differs between browsers.
      const isValid = moment(value, [DATETIME_FORMAT.IO_FORMAT, DATE_FORMAT.IO_FORMAT], true).isValid();
      return isValid ? "" : i18next.t("invalid_datetime");
    } else {
      return VALIDATION_MESSAGE.REQUIRED;
    }
  },
};

export default Validation;
